import { InvoiceDeliveryMethod } from './const/enum';

export class InvoiceDeliveryMethods {
  methods: InvoiceDeliveryMethod[];
  isB2CActive: boolean;
}
